import type { Tool } from './helpers'

// Left-rail tool selector button. Extracted verbatim from Designer.tsx.
export default function ToolBtn(
  { id, label, tool, setTool, children }:
  { id: Tool; label: string; tool: Tool; setTool: (t: Tool) => void; children: React.ReactNode },
) {
  const active = tool === id
  return (
    <button onClick={() => setTool(id)}
      className={`flex flex-col items-center justify-center gap-1.5 w-full py-3 px-2 text-[10px] uppercase tracking-wider font-semibold border-l-2 transition-colors ${active ? 'text-gold border-gold bg-white/5' : 'text-white/55 border-transparent hover:text-white hover:bg-white/5'}`}>
      {children}
      {label}
    </button>
  )
}
